/*
 * Created on Mon Dec 27 2021
 *
 * Copyright (c) 2021 Cohart Inc - All Rights Reserved
 * Unauthorized copying of this file via any medium is strictly prohibited
 * Proprietary and confidential
 * Copyright terms written by Cohart Inc <support@cohart.co>, Mon Dec 27 2021
 */

export { UserTitleStamp } from './enums'

export const ITEMS_PER_PAGE = 12

export const NODE_ENV = process.env.NODE_ENV
export const NEXT_APP_ENV = process.env.NEXT_APP_ENV

export const IS_PROD = NEXT_APP_ENV === 'production'
export const IS_PRE_PROD = NEXT_APP_ENV === 'pre-production'
export const IS_STAGING = NODE_ENV !== 'development' && NEXT_APP_ENV === 'staging'
export const IS_PREVIEW = NEXT_APP_ENV?.includes('preview')
export const IS_DEVELOPMENT = NODE_ENV === 'development'

export const WEB_BASE_URL = IS_DEVELOPMENT
  ? `${process.env.NEXT_PUBLIC_WEB_BASE_URL_DEV || 'local.cohdev.co'}:3000`
  : process.env.NEXT_PUBLIC_WEB_BASE_URL

// authentication session timeout (maxAge) in seconds
export const SESSION_TIMEOUT_IN_SECONDS = 86400 * 7 // 7 days

//  google analytics
export const GOOGLE_ANALYTICS_GA4 = process.env.GOOGLE_ANALYTICS_GA4

//  google recaptcha v2
export const GOOGLE_RECAPTCHAV3_SITE_KEY = process.env.GOOGLE_RECAPTCHAV3_SITE_KEY

// google tag manager
export const GOOGLE_TAG_MANAGER_CONTAINER_ID = process.env.GOOGLE_TAG_MANAGER_CONTAINER_ID

//  Branch.io live key
export const BRANCHIO_KEY = process.env.BRANCHIO_KEY

//  pinata api key and secret
export const PINATA_API_KEY = process.env.PINATA_API_KEY
export const PINATA_API_SECRET = process.env.PINATA_API_SECRET

export const GENERAL_ERROR = "We're sorry, an error has occurred 🤯. Please try again later."
export const GENERAL_SUCCESS = 'Success'

// For use when under construction
export const IS_UNDER_CONSTRUCTION = false

export const NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY

export const CMS_DOMAIN = process.env.NEXT_PUBLIC_CMS_DOMAIN

export const PAYPAL_CLIENT_ID = process.env.PAYPAL_CLIENT_ID
